<template>
    <div class="layout__padding-clear">
        <div class="text__align-center text__colour-teal layout__margin__bottom-25px colour__background__grey-f7f8fa">
            <div class="layout__padding-clear layout__padding-20px">
                <div class="text__colour-teal text__size-45 text__style-bold-700">Motion Graphics</div>
            </div>
        </div>

        <div class="layout__padding-clear layout__width-75">
            <div class="component__columns-2 layout__margin-20-0">
                <div class="layout__padding-clear">
                    <video class="layout__width-90 layout__padding__bottom-25px" controls autoplay loop>
                        <source src="https://rpsassets.blob.core.windows.net/rpsimages/Kensington-house-microsite.mp4" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>
            <div class="component__columns-2 layout__margin-20-0">
                <h3 class="text__colour-teal text__style-bold-900">Get your brand moving with animated motion
                    graphics.</h3>

                <div class="text__size-16 text__colour-grey layout__padding-20-0 text__line-height-20px">
                    Animation is a great way to add some personality to your brand. Try animating your corporate logo
                    for digital window displays and desktop screensavers – it adds that extra level of polish and helps
                    promote your brand even when you’re not in the office.
                </div>

                <div class="layout__padding-20-0">
                    <el-button class="layout__width-200px button-red"
                               v-on:click="contactUs()">Find out more
                    </el-button>
                </div>
            </div>
        </div>

        <div class="layout__padding-20px colour__background__grey-f7f8fa layout__padding-clear layout__overflow-hidden">
            <div class="text__size-30 text__align-center text__colour-teal text__style-bold-900 layout__padding-20px">
                You may also like
            </div>

            <div class="layout__width-80 layout__padding-clear">

                <router-link class="link__colour-black" to="/products/digital/animated-brochure">
                    <div class="component__product-3">
                        <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/animated-brochure-720x500.png" class="layout__width-100">
                        <div class="component__product__subtitles">
                            <div>Animated Brochure</div>
                        </div>
                    </div>
                </router-link>

                <router-link class="link__colour-black" to="/products/digital/digital-window-cards">
                    <div class="component__product-3">
                        <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/digiwindowcard.png" class="layout__width-100">
                        <div class="component__product__subtitles">
                            <div>Digital Window Cards</div>
                        </div>
                    </div>
                </router-link>

                <router-link class="link__colour-black" to="/products/digital/social-media">
                    <div class="component__product-3">
                        <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/socialmediamock.jpg" class="layout__width-100">
                        <div class="component__product__subtitles">
                            <div>Social Media</div>
                        </div>
                    </div>
                </router-link>
            </div>
        </div>


    </div>

</template>

<script>

    import Router from '../../../router';

    export default {
        name: "MG",
        components: {},
        data() {
            return {}
        },
        created() {
        },
        methods: {
            contactUs() {
                Router.push({
                    name: '/contact'
                });
            }
        }
    };
</script>